import React from 'react'
import { useHistory } from 'react-router-dom'
import { MagentoConfigurableProductOptions } from 'lib/types'
import { SIZES } from 'resources/constants'
import { Container } from './styled'

const MAX_ITEMS = 7

export const SWATCHES_ATTRIBUTES = {
  SIZE: 'size'
}

interface Props {
  options?: MagentoConfigurableProductOptions[]
  productPath?: string
}

export const Variants: React.FC<Props> = ({ options, productPath }) => {
  const history = useHistory()
  if (!options || !options.length) {
    return null
  }

  const swatches = getSwatches(options)
  const length = swatches.length

  return (
    <Container>
      <ul>
        {swatches.map((item, i) => {
          const { attrId, value, label } = item

          if ((i + 1) > MAX_ITEMS) {
            return null
          }

          return (
            <li
              key={`${attrId}-${value}-${i}`}
            >
              <button
                type='button'
                aria-label='swatch'
                onClick={() => history.push(`${productPath}?option=${value}`)}
              >
                <span>{SIZES[label] ?? label}</span>
              </button>
            </li>
          )
        })}

        {(length > MAX_ITEMS) && (
          <li>
            <small>
              + {length - MAX_ITEMS} more
            </small>
          </li>
        )}
      </ul>
    </Container>
  )
}

interface SwitchItem {
  attrId: number
  label: string
  value: number
  swatch: string
}

const SWATCHES = [
  SWATCHES_ATTRIBUTES.SIZE
]

const getSwatches = (options: MagentoConfigurableProductOptions[]): SwitchItem[] => {
  const swatches: SwitchItem[] = []

  options.forEach(option => {
    const {
      id: attrId,
      values,
      attribute_code: attrCode
    } = option

    if (!SWATCHES.includes(attrCode)) {
      return
    }

    values.forEach(item => {
      const {
        label,
        value_index: value,
        visiture_swatch_data: swatchData
      } = item

      const swatch = swatchData?.value

      swatches.push({
        attrId,
        label,
        value,
        swatch
      })
    })
  })

  return swatches
}
